import { render } from "./the-header.vue?vue&type=template&id=84fac4b6&scoped=true&ts=true"
import script from "./the-header.vue?vue&type=script&lang=ts"
export * from "./the-header.vue?vue&type=script&lang=ts"

import "./the-header.vue?vue&type=style&index=0&id=84fac4b6&lang=scss&scoped=true"

import exportComponent from "C:\\Build\\vsts-agent-win-x64-3.218.0\\_work\\1\\s\\Connect\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84fac4b6"]])

export default __exports__